export enum InvoiceResponseStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export interface RawInvoiceApiResponse {
  id: string;
  status: InvoiceResponseStatus;
  month: string;
  created_at: string;
  updated_at: string | undefined;
}
